// Mirrors every other migrated feature's slice.js shape (selectedFilters
// only, REHYDRATE normalization) - does NOT carry forward the old
// features/userFeature/slice.js's 8 dead fields (`users` - write-only,
// nothing ever read state.userFeature.users; `customColumns` - also
// write-only, the filters hook already read columns from local useState in
// parallel; `openUserModal`/`openConfirmationModal` - never dispatched;
// `queryParams`/`pagination` - explicitly commented "kept for persist/
// backward compat" in the old code, never actually read; `isUsersLoading`/
// `isFetchingUsers` - never dispatched, real loading state already came
// from RTK Query) or its `modalState`/`confirmationModal` (genuinely live,
// but pure page-local UI state that belongs in local useState, not Redux -
// moved to _features/userManagement/pages/UserManagementPage/index.jsx,
// matching every other migrated list page's isFormModalOpen/formMode/
// selectedRow/confirmationModalData shape).
//
// Field renamed from the old `selectedUserFilters` to `selectedFilters` to
// match every sibling migrated slice's field name - safe, nothing outside
// this feature's own (rewritten) hooks ever read the old field name
// directly.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const userFeatureSlice = createSlice({
  name: "userFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.userFeature) {
        const persistedData = action.payload.userFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...(persistedData.selectedFilters && typeof persistedData.selectedFilters === "object"
              ? persistedData.selectedFilters
              : {}),
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = userFeatureSlice.actions;

export default userFeatureSlice.reducer;
